/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';
import { ID } from '@gh/common-shared-data';

export type Usages = {
  deleted: boolean;
  itemId: ID;
  version: number;
};

export type BulkUsageResponse = {
  allDeleted: boolean;
  usages: Usages[];
};

export type UsageDto = {
  code: string;
  name: string;
  usage: UsageListItemDto[];
};

export type UsageListItemDto = {
  entityName: string;
  entityType: string;
};

export const UsageEntityType = createEnum('VIEW_USAGE_TYPE', {
  HOUSE_PLAN_USAGE_INFO: 'HOUSE_PLAN_USAGE_INFO',
  CC_USAGE_INFO: 'CC_USAGE_INFO',
  ITEMS_USAGE_INFO: 'ITEMS_USAGE_INFO',
  COMPONENTS_USAGE_INFO: 'COMPONENTS_USAGE_INFO',
  SPEC_TEMPLATE_USAGE_INFO: 'SPEC_TEMPLATE_USAGE_INFO',
  CS_MASTER_USAGE_INFO: 'CS_MASTER_USAGE_INFO',
  SCH_TEMPLATE_USAGE_INFO: 'SCH_TEMPLATE_USAGE_INFO',
});

export const BulkActionEntityType = {
  costCenters: 'cost-centers',
  components: 'components',
  items: 'items',
  takeOffParams: 'take-off-params',
  uom: 'units-of-measures',
};

export type UsageEntityType = EnumSet<typeof UsageEntityType>;
